import {
    Accordion,
    createAccordion,
} from '@vfde-brix/ws10/accordion';
import {
    ContentId,
    HtmlId,
    Kip1000CableMax,
} from '../enums/elementId';
import { mountComponent } from '../util/mount';
import { trackFaqAccordion } from '../tracking/tracking';
import {
    FootnoteHtmlContent,
    SessionAppState,
} from '../interface';
import { isIndexFound } from '../util/typeGuard';
import { getCookie } from '@vfde-sails/utils';
import { Cookies } from '../enum';
import { getSessionStorageItemJson } from '@vfde-sails/storage';
import { STORAGE_KEY } from '../constants';
import {
    CUSTOMER_TYPE_UM,
    CUSTOMER_TYPE_VKD,
} from '@vfde-sails/constants';
import { isPlaystationPromoActive } from '../util/cms';

/**
 * Mount accordion component
 */
export const mountAccordion = (id: HtmlId) =>
    mountComponent(id, createAccordion, {
        onToggle: props => {
            props.optOpen && trackFaqAccordion?.(props.stdHeadline);
        },
    });

/**
 * Mounts footnote accordion on page init once
 * Returns component for each container
 */
export const footnoteAccordion = (() =>
    mountAccordion(ContentId.FOOTNOTE_ACCORDION)
)();

/**
 * Closes the accordion
 */
export const closeAccordion = (accordion: Accordion) => {
    const { items } = accordion.getProperties();
    const fnfCookieToken = getCookie(Cookies.FF);
    const mddkeksCookieToken = getCookie(Cookies.MDD_KEKS);
    const decodedValue = mddkeksCookieToken && decodeURIComponent(mddkeksCookieToken);
    // Parse the decoded value into an object
    const parsedObject = decodedValue && JSON.parse(decodedValue);
    const cableType = !!(parsedObject && (parsedObject.customerType === CUSTOMER_TYPE_VKD ||
        parsedObject.customerType === CUSTOMER_TYPE_UM));

    const sessionState: SessionAppState | null = getSessionStorageItemJson(STORAGE_KEY);

    for (const item of items) {
        if (item.stdId === ContentId.FNF_ACCORDION && !fnfCookieToken) {
            item.optHidden = true;
        }

        if (item.stdId === ContentId.PS_ACCORDION &&
            (!isPlaystationPromoActive() || cableType ||
            !(Object.values(Kip1000CableMax).includes(sessionState?.cable.selectedTariffId as Kip1000CableMax)))) {
            item.optHidden = true;
        }

        item.optOpen = false;
    }

    accordion.update({ items });
};

/**
 * Removes the dynamic TV footnote if exists.
 */
export const removeTvConnectAccordionItem = () => {
    if (!footnoteAccordion) {
        return;
    }

    const { items } = footnoteAccordion.getProperties();
    const dynamicItemIndex = items.findIndex(item => item.stdId === ContentId.FOOTNOTE_DYNAMIC_ITEM);

    if (!isIndexFound(dynamicItemIndex)) {
        return;
    }

    items.splice(dynamicItemIndex, 1);

    footnoteAccordion.update({ items });
};

/**
 * Creates the dynamic TV footnote if not exists.
 */
export const createFootnoteAccordionItem = (footnoteContent: FootnoteHtmlContent) => {
    if (!footnoteAccordion) {
        return;
    }

    const { items } = footnoteAccordion.getProperties();
    const dynamicItemIndex = items.findIndex(item => item.stdId === ContentId.FOOTNOTE_DYNAMIC_ITEM);

    if (isIndexFound(dynamicItemIndex)) {
        return;
    }

    items.splice(4, 0, {
        stdId: ContentId.FOOTNOTE_DYNAMIC_ITEM,
        stdIconLeft: items[0]?.stdIconLeft,
        stdHeadline: footnoteContent.accordionTitle,
        containerAnyComponent: footnoteContent.contentTitle + footnoteContent.content,
    });

    footnoteAccordion?.update({ items });
};
